import { CindyButton, Stack, Typography } from '@ace-clublabs/shared-component-library';

export interface ICindyBubbleProps {
  message?: string;
  className?: string;
  id?: string;
  buttons?: {
    id?: string;
    buttonTitle: string;
    onClick: () => void;
  }[];
}
export const CindyBubble = ({ message, className, id, buttons }: ICindyBubbleProps) => {
  return (
    <div className={`cindy-container-root ${className}`} id={id}>
      {message && (
        <Typography variant="b2Regular" className={`${className}-message`}>
          {message}
        </Typography>
      )}

      <Stack direction={'row'} gap={'8px'}>
        {buttons &&
          buttons.length > 0 &&
          buttons?.map((button, i) => {
            return (
              <CindyButton
                key={`cindy-button-${i}`}
                id={button.id}
                sx={{
                  borderRadius: '50px',
                  padding: '4px 16px !important',
                  marginTop: '8px',
                  fontSize: '14px !important',
                }}
                label={button.buttonTitle}
                onClick={button.onClick}
              />
            );
          })}
      </Stack>
    </div>
  );
};
